import React from 'react';
import ZoneIntervention from '../components/ZoneIntervention';
import { ZONES_SEO } from '../seo/pagesSeo';

function Zone75() {
    const seo = ZONES_SEO['75'];
     const cities = [
        "Antiquaire 1er Arrondissement 75001",

        "Antiquaire Quartier du Louvre 75001",
        "Antiquaire Quartier de la Place Vendôme 75001",
        "Antiquaire Quartier des Halles 75001",
        "Antiquaire Quartier Saint-Germain-l’Auxerrois 75001",
        "Antiquaire Quartier du Palais-Royal 75001",

        "Antiquaire 2e Arrondissement 75002",

        "Antiquaire Quartier de la Bourse 75002",
        "Antiquaire Quartier du Mail 75002",
        "Antiquaire Quartier des Petits-Champs 75002",
        "Antiquaire Quartier de la Porte-Saint-Denis 75002",
        "Antiquaire Quartier de la Porte-Saint-Martin 75002",

        "Antiquaire 3e Arrondissement 75003",

        "Antiquaire Quartier du Marais 75003",
        "Antiquaire Quartier des Archives 75003",
        "Antiquaire Quartier de la Place des Vosges 75003",
        "Antiquaire Quartier de la Sainte-Croix de la Bretonnerie 75003",
        "Antiquaire Quartier du Temple 75003",

        "Antiquaire 4e Arrondissement 75004",

        "Antiquaire Quartier du Marais 75004",
        "Antiquaire Quartier Saint-Gervais 75004",
        "Antiquaire Quartier de l’Arsenal 75004",
        "Antiquaire Quartier de l’Hôtel-de-Ville 75004",

        "Antiquaire 5e Arrondissement 75005",

        "Antiquaire Quartier du Jardin-des-Plantes 75005",
        "Antiquaire Quartier de la Sorbonne 75005",
        "Antiquaire Quartier de la Contrescarpe 75005",
        "Antiquaire Quartier de Saint-Victor 75005",
        "Antiquaire Quartier de la Grande Mosquée 75005",

        "Antiquaire 6e Arrondissement 75006",

        "Antiquaire Quartier de l’Odéon 75006",
        "Antiquaire Quartier Saint-Germain-des-Prés 75006",
        "Antiquaire Quartier de la Monnaie 75006",
        "Antiquaire Quartier de l’Université 75006",

        "Antiquaire 7e Arrondissement 75007",

        "Antiquaire Quartier de l’Assemblée Nationale 75007",
        "Antiquaire Quartier du Gros-Caillou 75007",
        "Antiquaire Quartier de l’École Militaire 75007",
        "Antiquaire Quartier de Saint-Thomas-d’Aquin 75007",

        "Antiquaire 8e Arrondissement 75008",

        "Antiquaire Quartier de la Madeleine 75008",
        "Antiquaire Quartier de l’Élysée 75008",
        "Antiquaire Quartier de l’Opéra 75008",
        "Antiquaire Quartier du Faubourg-du-Roule 75008",
        "Antiquaire Quartier de la Concorde 75008",

        "Antiquaire 9e Arrondissement 75009",

        "Antiquaire Quartier de l’Opéra 75009",
        "Antiquaire Quartier Saint-Georges 75009",
        "Antiquaire Quartier de la Nouvelle-Athènes 75009",
        "Antiquaire Quartier de la Trinité 75009",
        "Antiquaire Quartier de Rochechouart 75009",

        "Antiquaire 10e Arrondissement 75010",

        "Antiquaire Quartier de la Porte-Saint-Denis 75010",
        "Antiquaire Quartier de la Porte-Saint-Martin 75010",
        "Antiquaire Quartier de la Villette 75010",
        "Antiquaire Quartier du Canal Saint-Martin 75010",

        "Antiquaire 11e Arrondissement 75011",

        "Antiquaire Quartier de la Bastille 75011",
        "Antiquaire Quartier de la Roquette 75011",
        "Antiquaire Quartier de Saint-Antoine 75011",
        "Antiquaire Quartier de la Folie-Méricourt 75011",

        "Antiquaire 12e Arrondissement 75012",

        "Antiquaire Quartier de Bercy 75012",
        "Antiquaire Quartier de la Gare de Lyon 75012",
        "Antiquaire Quartier de Reuilly 75012",
        "Antiquaire Quartier de Picpus 75012",

        "Antiquaire 13e Arrondissement 75013",

        "Antiquaire Quartier de la Gare d’Austerlitz 75013",
        "Antiquaire Quartier de la Place d’Italie 75013",
        "Antiquaire Quartier de la Butte-aux-Cailles 75013",
        "Antiquaire Quartier de la Maison-Blanche 75013",
        "Antiquaire Quartier de Croulebarbe 75013",

        "Antiquaire 14e Arrondissement 75014",

        "Antiquaire Quartier du Montparnasse 75014",
        "Antiquaire Quartier de la Gare Montparnasse 75014",
        "Antiquaire Quartier de l’Observatoire 75014",
        "Antiquaire Quartier de Plaisance 75014",
        "Antiquaire Quartier de la Porte d’Orléans 75014",

        "Antiquaire 15e Arrondissement 75015",

        "Antiquaire Quartier de la Gare Montparnasse 75015",
        "Antiquaire Quartier de la Vaugirard 75015",
        "Antiquaire Quartier de Javel 75015",
        "Antiquaire Quartier de la Convention 75015",
        "Antiquaire Quartier de Grenelle 75015",

        "Antiquaire 16e Arrondissement 75016",

        "Antiquaire Quartier de Passy 75016",
        "Antiquaire Quartier de la Muette 75016",
        "Antiquaire Quartier de la Porte-Dauphine 75016",
        "Antiquaire Quartier du Trocadéro 75016",
        "Antiquaire Quartier de la Porte-de-Saint-Cloud 75016",

        "Antiquaire 17e Arrondissement 75017",

        "Antiquaire Quartier des Batignolles 75017",
        "Antiquaire Quartier des Épinettes 75017",
        "Antiquaire Quartier de la Plaine-de-Monceaux 75017",
        "Antiquaire Quartier de la Ternes 75017",
        "Antiquaire Quartier de Villiers 75017",

        "Antiquaire 18e Arrondissement 75018",

        "Antiquaire Quartier de la Goutte-d’Or 75018",
        "Antiquaire Quartier de Montmartre 75018",
        "Antiquaire Quartier de la Clignancourt 75018",
        "Antiquaire Quartier de la Chapelle 75018",
        "Antiquaire Quartier de la Porte de Clignancourt 75018",

        "Antiquaire 19e Arrondissement 75019",

        "Antiquaire Quartier de la Villette 75019",
        "Antiquaire Quartier de la Butte-du-Chapeau-Rouge 75019",
        "Antiquaire Quartier de la Porte de la Villette 75019",
        "Antiquaire Quartier du Parc de la Villette 75019",

        "Antiquaire 20e Arrondissement 75020",

        "Antiquaire Quartier de Belleville 75020",
        "Antiquaire Quartier de Ménilmontant 75020",
        "Antiquaire Quartier de la Campagne-à-Paris 75020",
        "Antiquaire Quartier de Charonne 75020",
        "Antiquaire Quartier de Saint-Fargeau 75020"
    ];
    return <ZoneIntervention departmentName="Paris (75)" cities={cities} seoTitle={seo.title} seoDescription={seo.description} seoPath={seo.path} />;
}

export default Zone75;
